ehVisualiza<template>
  <div>
    <div
      class="d-flex mb-8"
    >
      <div class="titulo-pagina">
        {{ this.$t('modulos.frequencia_calibracao.titulos.editar') }}
      </div>
    </div>
    <div
      id="template-email"
      class="template-email"
    >
      <EmailEditor
        ref="emailEditor"
        :class="{ 'email-editor': true }"
        :appearance="appearance"
        :min-height="minHeight"
        :project-id="projectId"
        :locale="locale"
        :tools="tools"
        :options="options"
        @load="buscarFrequenciaCalibracao"
      />
    </div>
    <div
      class="d-flex align-center justify-end mt-4 pr-2 mb-2"
    >
      <botao-padrao
        outlined
        color="secondary"
        class="mr-2"
        @click="cancelar"
      >
        <v-icon>$mdiCancel</v-icon>
        {{ $t('geral.botoes.cancelar') }}
      </botao-padrao>
      <botao-padrao
        @click="saveDesign(true)"
      >
        <v-icon>$mdiContentSaveOutline</v-icon>
        {{ $t('geral.botoes.salvar') }}
      </botao-padrao>
    </div>
  </div>
</template>
<script>
import FrequenciaCalibracaoService from '@common/services/cadastros/FrequenciaCalibracaoService';
import helpers from '@common/utils/helpers';
import { EmailEditor } from 'vue-email-editor';
import { FrequenciaCalibracaoModel } from '@common/models/cadastros/FrequenciaCalibracaoModel.js';
export default {
  components: {
    EmailEditor,
  },
    props: {
    id: { type:String, default:'' },
  },
  data() {
    return {
      form: new FrequenciaCalibracaoModel({}),
      minHeight: '95vh',
      locale: 'pt-BR',
      projectId: 0,
      tools: {
        image: {
          enabled: true,
        },
      },
      options: {
        devices: ['desktop'],
      },
      appearance: {
        theme: 'dark',
        panels: {
          tools: {
            dock: 'right',
          },
        },
      },
    };
  },
  watch: {
    form: {
      handler() {
        this.$emit('form-frequencia-calibracao', this.form)
      },
      immediate: true,
      opcoes: { booleano: helpers.BoleanoEnum },
      variaveisMenu: [],
      variaveisListaMenu: [],
      editorId: 'template-email-editor',
      minHeight: '95vh',
      locale: 'pt-BR',
      projectId: 0,
      tools: {
        image: {
          enabled: true,
        },
      },
      options: {
        devices: ['desktop'],
      },
      appearance: {
        theme: 'dark',
        panels: {
          tools: {
            dock: 'right',
          },
        },
      },
    },
  },
  mounted() {
      helpers.redirecionarSemPermissao(this, 'FrequenciaCalibracao', 'Editar')
  },
  methods: {
    cancelar: function () {
      this.confirmarCancelar().then(() => {
        this.$router.push({ name: 'frequencia-calibracao' });
      });
    },
    buscarFrequenciaCalibracao: async function () {
     this.$store.dispatch('Layout/iniciarCarregamento');
      FrequenciaCalibracaoService.listar()
        .then((res) => {
          this.form = new FrequenciaCalibracaoModel({...res.data});
          if (this.form.designJson)
            this.$refs.emailEditor.editor.loadDesign(this.form.designJson);
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
   async saveDesign() {
     this.$store.dispatch('Layout/iniciarCarregamento');
      this.$refs.emailEditor.editor.exportHtml(async (design) => {
        this.form.designJson = design.design;
        this.form.html = design.html;
        await FrequenciaCalibracaoService.salvar(this.form.request)
          .then(() => {
            this.toastSucesso(
              this.$t('modulos.frequencia_calibracao.cadastro_sucesso')
            );
            this.$router.push({ name: 'frequencia-calibracao' });
          })
          .finally(() => {
            this.$store.dispatch('Layout/terminarCarregamento');
          });
      });
    },
  },
};
</script>
<style lang="scss">

@media (max-width: 768px) {

  .template-email {
    flex-direction: column;
  }
}

.template-email {
  display: flex;
  gap: 8px;
  width: 100%;
  height: 100%;
  border-radius: 10px;

  .email-editor {
    width: 95vw;
    height: 80vh;
    border-radius: 10px;
  }

  .variaveis-item {
    display: flex;
    overflow-y: auto;
    gap: 8px;
    padding: 8px 16px;
    width: 100% !important;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background-color: #e0e0e0;
    }
  }

  .variaveis-item + .variaveis-item {
    border-top: 1px solid #e0e0e0 !important;
  }


  .blockHover:hover {
    cursor: not-allowed;
  }
}
</style>
